module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"other":"Ваша камера недоступна. Воспользуйтесь другим устройством."}}')
  delete Component.options._Ctor
}
